<script lang="ts">
    
    import { createEventDispatcher } from "svelte";
    import type { AnyActivity } from "../../global";

    export let activity: AnyActivity;

    const dispatch = createEventDispatcher();
    const isCompleted = activity.isCompleted;

    function onClick(): void {
        dispatch('click', activity);
    }

</script>
<button type="button" class="activity-btn" class:is-completed={$isCompleted} on:click={onClick}>
    <slot />
</button>

<style lang="scss">

    .activity-btn {
        width: 60px;
        height: 40px;
        border: none;
        background-color: var(--color-primary);    
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        &.is-completed {
            background-color: rgba(var(--color-primary-rgb), 0.5);
        }

        &:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }

        &:last-child {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }

</style>